import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useActivityPinnedNotes } from '../../activity-feed/hooks/use-activity-pinned-notes.ts';
import { ActivityFeedNoteItem } from './activity-feed-note-item.tsx';
import { FeedSection } from './feed-section.tsx';

export type PinnedNotesSectionProps = {
    customerId: string;
};

/**
 * The customer's pinned notes, above "Anstehend"
 *
 * The feed query asks for `pinned: false`, so a pinned note is deliberately absent from
 * "Vergangen" and this is the only place it appears. Renders nothing while there is
 * none, rather than a section with an empty state.
 */
export function PinnedNotesSection({ customerId }: PinnedNotesSectionProps): ReactElement | null {
    const { t } = useTranslation('activity-feed');
    const { notes, isLoading } = useActivityPinnedNotes(customerId);

    if (notes.length === 0) {
        return null;
    }

    return (
        <FeedSection title={t('feed__pinned')} isLoading={isLoading} isEmpty={false}>
            <div className="flex flex-col gap-cozy">
                {notes.map((note) => (
                    <ActivityFeedNoteItem key={note.noteId} note={note} />
                ))}
            </div>
        </FeedSection>
    );
}
